import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
  en: {
    tooltip: (startTime: string, minutes: number) => `${startTime} - ${minutes} minutes`
  }
});
